var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7035 0.0055264L1.75684 0.378916C1.10502 0.428119 0.562891 0.904872 0.438561 1.54845C-0.766378 7.78566 0.476111 13.4324 4.60628 17.4917C8.72013 21.535 14.4177 22.7457 20.76 21.5811C21.4414 21.4559 21.9431 20.8683 21.9503 20.1734L22.0046 14.9404C22.015 13.9322 21.2289 13.0978 20.2218 13.0317L16.1706 12.7658L15.9894 12.7625C15.5082 12.7762 15.0467 12.9702 14.7008 13.3101L12.7977 15.181L6.92668 9.41103L8.78034 7.59024C9.20462 7.17323 9.40825 6.58252 9.32866 5.99375L8.74036 1.64178C8.60544 0.643675 7.70892 -0.0703698 6.7035 0.0055264ZM6.77068 2.00503L7.33868 6.20103L5.4425 8.06656C4.68884 8.8073 4.68884 10.0156 5.4425 10.7563L11.4538 16.6645L11.5819 16.7796C12.3297 17.3935 13.4384 17.3552 14.1411 16.6645L16.0747 14.763L20.0037 15.021L19.9547 19.69L19.5818 19.7504C14.1688 20.5628 9.43229 19.4307 6.00821 16.0653L5.76109 15.8162C2.52035 12.463 1.44231 7.88751 2.26468 2.70902L2.32568 2.34103L6.77068 2.00503Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.d4fae9e9.svg";
export { ForwardRef as ReactComponent };